import React, { FC } from 'react'
import { Button, ButtonProps } from '@chakra-ui/react'

interface IconButtonProps extends ButtonProps {
  buttonText: string
  icon: JSX.Element
  onClick?: () => void
}

export const IconButtonSecondary: FC<IconButtonProps> = ({
  buttonText,
  icon,
  onClick,
  ...rest
}) => {
  return (
    <Button
      leftIcon={icon}
      variant='outline'
      borderColor='#E0E0E0'
      borderWidth='1px'
      size='sm'
      padding={5}
      textColor='#6F7070'
      fontWeight={300}
      onClick={onClick}
      bgColor={'white'}
      color={'#6F7070'}
      rounded={'md'}
      _hover={{
        'svg path[data-color="custom"]': {
          stroke: 'primary.500',
          fill: 'primary.500',
          strokeWidth: 0.2,
        },
        color: 'black',
        backgroundColor: 'primary.50',
        borderColor: 'primary.200',
      }}
      {...rest}
    >
      {buttonText}
    </Button>
  )
}
